"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEllipsisItems = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var getBufferList = function getBufferList(start, end, config) {
  var EllipsisComponent = config.EllipsisComponent,
    ellipsisProps = config.ellipsisProps,
    items = config.items,
    spritemap = config.spritemap;
  var removedItems = items.slice(start, Math.max(end, start));
  if (removedItems.length > 1) {
    return [/*#__PURE__*/_react.default.createElement(EllipsisComponent, _extends({
      items: removedItems,
      key: "ellipsisComponent",
      spritemap: spritemap
    }, ellipsisProps))];
  }
  return removedItems;
};
var getEllipsisItems = exports.getEllipsisItems = function getEllipsisItems(config, ellipsisBuffer) {
  var activeIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var items = config.items;
  var lastIndex = items.length - 1;
  var leftBufferEnd = activeIndex - ellipsisBuffer;
  var rightBufferStart = activeIndex + ellipsisBuffer + 1;
  var leftBuffer = getBufferList(1, leftBufferEnd, config);
  var rightBuffer = getBufferList(rightBufferStart, lastIndex, config);
  var newArray = [items[0]].concat(_toConsumableArray(leftBuffer), _toConsumableArray(items.slice(Math.max(activeIndex - ellipsisBuffer, 1),
  // Add 1 to account for active index
  Math.min(activeIndex + ellipsisBuffer + 1, lastIndex))), _toConsumableArray(rightBuffer));
  if (items.length > 1) {
    newArray.push(items[lastIndex]);
  }
  return newArray;
};